import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './WhyHostNew.css';
import { graphql, gql, compose } from 'react-apollo';
import Scroll from 'react-scroll'; // Imports all Mixins

import EarnBlock from '../../components/WhyHost/EarnBlock/EarnBlock';
import EasyHost from '../../components/WhyHost/EasyHost/EasyHost';
import Peace from '../../components/WhyHost/Peace/Peace';
import Works from '../../components/WhyHost/Works/Works';
import WhyHostBanner from './WhyHostBanner';
import WhyBlock from '../../components/WhyHost/WhyBlock';
import Loader from '../../components/Loader';
import SharingSection from '../../components/WhyHost/SharingSection/SharingSection';
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import getWhyHostReview from './getWhyHostReview.graphql';

// Helper to get localized value from key-value data
const getLocalizedValue = (item, locale) => {
  if (!item) return '';
  const code = locale ? locale.substring(0, 2).toLowerCase() : 'es';
  if (code === 'es') return item.value || '';
  const localizedField = `value_${code}`;
  return item[localizedField] || item.value || '';
};

let Link = Scroll.Link;
let Element = Scroll.Element;
let Events = Scroll.Events;
let scroll = Scroll.animateScroll;
let scrollSpy = Scroll.scrollSpy;

class EditProfile extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    const { data: { getWhyHostPage }, title, locale } = this.props
    const { getWhyHostReview: { getHomeWhyHostReview } } = this.props;

    let settingsCollection = {}

    if (!getWhyHostPage || (getWhyHostPage?.length == 0)) {

      return <Loader type={"text"} />;

    } else {

      getWhyHostPage.map((item, key) => {
        // Use localized value based on current locale
        settingsCollection[item.name] = getLocalizedValue(item, locale);
      });

      return (
        <div className="whyhost-content">
          <WhyHostBanner data={settingsCollection} />
          <Element name="scrollSection" className="element">
            <EarnBlock data={settingsCollection} />
            <WhyBlock data={settingsCollection} />
            <EasyHost data={settingsCollection} />
            <Works data={settingsCollection} />
            {getHomeWhyHostReview && getHomeWhyHostReview.results && getHomeWhyHostReview.results.length > 0 && <Peace data={settingsCollection} reviewData={getHomeWhyHostReview.results} />}
            <SharingSection data={settingsCollection} />
          </Element>
        </div>
      );
    }

  }

}


const mapState = (state) => ({
  locale: state.intl.locale
});

export default compose(
  withStyles(s),
  connect(mapState),
  graphql(getWhyHostPageSettings, {
    options: {
      fetchPolicy: 'network-only',
      ssr: true
    }
  }),
  graphql(getWhyHostReview, {
    name: "getWhyHostReview",
    options: {
      fetchPolicy: 'network-only',
      ssr: true
    }
  })
)(EditProfile);
